
import { Info } from "lucide-react";

interface LegalContextSectionProps {
  content: string;
}

const LegalContextSection = ({ content }: LegalContextSectionProps) => {
  if (!content) return null;
  
  return (
    <div className="mt-3 p-3 bg-blue-50 border border-blue-100 rounded-md text-sm">
      <div className="flex items-start gap-2">
        <Info className="h-4 w-4 text-blue-500 mt-0.5 flex-shrink-0" />
        <div>
          <p className="font-medium text-blue-700 mb-1">Region-Specific Legal Context</p>
          <p className="text-blue-800">{content}</p>
        </div>
      </div>
    </div>
  );
};

export default LegalContextSection;
